import { Link } from 'react-router-dom';
import { getFeaturedVideos } from '@/mocks/videos';

export default function TrendingVideos() {
  const featuredVideos = getFeaturedVideos();

  return (
    <section className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-foreground-600 text-sm mt-2">
              全网最受欢迎的打屁股视频，大家都在看
            </p>
          </div>
          <Link
            to="/category/funny-prank-videos"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-colors hover:bg-background-100"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={video.thumbnailUrl}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
                  {video.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                    热门
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views >= 10000
                      ? `${(video.views / 10000).toFixed(1)}万`
                      : video.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {video.date}
                  </span>
                  <span className="flex items-center gap-1 text-primary-500">
                    <i className="ri-folder-line"></i>
                    {video.categoryName}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/funny-prank-videos"
            className="flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}